import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What is included in the initial $5,200 JMD consultation?",
    a: "A private, in-depth conversation covering the senior's daily needs, mobility, healthcare access, family logistics, and lifestyle goals. We leave you with a clear written assessment and recommendation — no obligation to continue.",
  },
  {
    q: "Are you a real estate or legal firm?",
    a: "No. All relocation services are strictly advisory and coordination-based. We refer clients to vetted real estate lawyers and licensed agents but do not provide legal counsel, brokerage, or financial advice.",
  },
  {
    q: "How do diaspora families stay informed?",
    a: "With the senior's consent, we maintain consistent written status reports and open communication loops with authorized family members overseas — including virtual walk-throughs of property and home.",
  },
  {
    q: "Are your caregivers background-checked?",
    a: "Yes. A clean Police Record is strictly mandatory for every team member before deployment. All caregivers hold HEART Trust NTA certification or are trained on-the-job by a certified HEART Trust NTA Instructor.",
  },
  {
    q: "Which parishes do you currently serve?",
    a: "Phase 1: Kingston, St. Andrew, St. Catherine. We are scaling thoughtfully into St. James, St. Ann, St. Elizabeth, and Manchester as Phase 2 & 3.",
  },
  {
    q: "Can in-home care continue after the relocation packages end?",
    a: "Yes. The Elite package includes 90 days of structured wellness check-ins, and all clients can seamlessly transition into a custom monthly in-home care subscription.",
  },
];

export default function FAQSection() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="honeycomb honeycomb--soft py-28 md:py-32"
      style={{
        background:
          "linear-gradient(180deg, #FDFDFD 0%, #F1F6F7 100%)",
      }}
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <span className="eyebrow">Frequently Asked</span>
          <h2 className="font-serif text-4xl sm:text-5xl text-[var(--gg-deep)] mt-5 leading-[1.05]">
            Questions families ask us most.
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-gray-200"
            >
              <AccordionTrigger className="font-serif text-lg md:text-xl text-[var(--gg-deep)] py-6 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[var(--gg-text)] leading-relaxed pb-6 text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
